export const isAbortError = (err: unknown) => {
  return (
    err instanceof DOMException &&
    (err.name === 'AbortError' || err.code == DOMException.ABORT_ERR)
  );
};

/*

That's not valid, should schedule next request only when current is settled
const usePolling = (cb: () => void) => {
  useEffect(() => {
    //polling
    const abortController = new AbortController();

    const interval = setInterval(() => {
      cb()
    }, 1000);

    return () => {
      clearInterval(interval);
      abortController.abort();
    };
  }, []);

}
*/
